/* eslint-disable no-unused-vars */
import { fireApp } from '@/helpers/_firebase'

function generateData (baseval, count, yrange) {
  var i = 0
  var series = []
  while (i < 5) {
    var x = Math.floor(Math.random() * (750 - 1 + 1)) + 1
    var y = Math.floor(Math.random() * (yrange.max - yrange.min + 1)) + yrange.min
    var z = Math.floor(Math.random() * (75 - 15 + 1)) + 15

    series.push([x, y, z])
    baseval += 86400000
    i++
  }
  return series
}

export default {
  name: 'dashboard',
  components: {},
  props: [],
  firestore: {
    influencers: fireApp.firestore().collection('influencers')
  },
  data () {
    return {
      influencers: [],
      length: 0,
      stadistics: [],
      influencerSerie: {
        name: '',
        data: []
      },
      series: [
        {
          name: 'Influencer X',
          data: [[13, 35, 200]]
        },
        {
          name: 'Influencer Y',
          data: [[8, 12, 150]]
        },
        {
          name: 'Influencer Z',
          data: [[5, 11, 300]]
        },
        {
          name: 'Influencer W',
          data: [[11, 20, 200]]
        }
      ],
      chartOptions: {
        chart: {
          height: '100px',
          type: 'bubble'
        },
        dataLabels: {
          enabled: true
        },
        fill: {
          opacity: 0.8
          // type: 'gradient'
        },
        title: {
          text: 'Leaderboards',
          style: {
            fontSize: '32px'
          },
          align: 'center'
        },
        // labels: ['Apples', 'Oranges', 'Berries', 'Grapes'],
        xaxis: {
          // tickAmount: 12,
          max: 200,
          // type: 'category'
          labels: {
            rotate: 0,
            show: false
          },
          tickPlacement: 'between'
        },
        yaxis: {
          tickAmount: 12,
          max: 500
        },
        theme: {
          palette: 'palette2'
        },
        zoom: {
          enabled: true,
          type: 'x',
          autoScaleYaxis: 'false'
        },
        grid: {
          padding: {
            left: 15
          }
        }
      },
      finished: false
    }
  },
  computed: {},
  mounted () {
    this.finished = false
  },
  watch: {
    influencers: {
      // deep: true,
      // immediate: true,
      handler: function (val, oldVal) {
        let name = ''
        let arr = []
        let x = 0
        let y = 0
        // let finished = false

        if (val.length > 0) {
          for (let influencer in val) {
            name = val[influencer].id
            if (!this.finished) {
              x = Math.floor(Math.random() * 200)
              y = Math.floor(Math.random() * 300)
            }
            // debugger
            for (let inf in val[influencer]) {
              var size = Object.keys(val[influencer][inf]).length
              // debugger
            }
            arr[0] = x
            arr[1] = y
            arr[2] = size
            this.influencerSerie.name = name
            this.influencerSerie.data.push([x, y, size])

            this.pushInfluencerData()
          }
          this.finished = true
        }
        // var size = Object.keys(val).length
        // this.length = size
      }
    }
  },
  methods: {
    pushInfluencerData () {
      // let arr = this.influencerSerie.data
      // psh.data.push(arr)
      let psh = {}
      psh.name = this.influencerSerie.name
      psh.data = []

      let influencer = this.stadistics.find(item => item.name === this.influencerSerie.name)

      if (this.finished) {
        if (!influencer) {
          this.influencerSerie.data[0][0] = Math.floor(Math.random() * 200)
          this.influencerSerie.data[0][1] = Math.floor(Math.random() * 300)
        } else {
          this.influencerSerie.data[0][0] = influencer.data[0][0]
          this.influencerSerie.data[0][1] = influencer.data[0][1]
        }
        // console.log(influencer.data[0][0])
        // console.log()
      }

      psh.data = this.influencerSerie.data

      if (influencer) {
        const index = this.stadistics.indexOf(influencer)
        if (index > -1) {
          this.stadistics.splice(index, 1)
        }
        // return
      }
      this.stadistics.push(psh)

      this.influencerSerie.name = ''
      this.influencerSerie.data = []

      // debugger
    }
  }
}
